"use client";

import { ComparisonTable } from "@/components/compare/comparison-table";

export function Comparison() {
	return <ComparisonTable competitor="openrouter" />;
}
